const scrollToTop = document.querySelector('.scroll-to-top');

if (scrollToTop) {
	toggleScrollTopVisibility();

	window.addEventListener('scroll', () => {
		toggleScrollTopVisibility();
	});

	scrollToTop.addEventListener('click', () => {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	});
}

function toggleScrollTopVisibility(scrollHeight = 100) {
	if (window.scrollY > scrollHeight) {
		scrollToTop.classList.add('opacity-100');
		scrollToTop.classList.remove('opacity-0');
	} else {
		scrollToTop.classList.add('opacity-0');
		scrollToTop.classList.remove('opacity-100');
	}
}
